import { API_ROOT } from '../constants'
import api from '../utils/api'

export const refund = (data, config) => {
  return api.post(`${API_ROOT}/v3/subscription/request-refund`, data, config)
}
